
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/search",
      function () {
        return require("private-next-pages/guide/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/search"])
      });
    }
  